import { render, staticRenderFns } from "./PlanPartnersInfo.vue?vue&type=template&id=e90a0f9e&scoped=true"
import script from "./PlanPartnersInfo.vue?vue&type=script&lang=js"
export * from "./PlanPartnersInfo.vue?vue&type=script&lang=js"
import style0 from "./PlanPartnersInfo.vue?vue&type=style&index=0&id=e90a0f9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e90a0f9e",
  null
  
)

export default component.exports